<template>
    <div :class="['order-container align-items-center flex-column', classCard]" v-if="quotation.error">
        <img class="img-parcel" style="max-width: 200px;" :src="`${utils.getParcelImage(quotation.parcelCompany)}`" :alt="utils.getParcelLabel(quotation.parcelCompany)">
        <label class="mt-1">{{quotation.data}}</label>
    </div>

    <div :class="['order-container align-items-center flex-column', classCard]" v-else>
        <div class="parcel-wrapper">
            <img
                class="img-parcel"
                style="max-width: 200px;"
                :src="`${utils.getParcelImage(quotation.parcelCompany)}`"
                :alt="utils.getParcelLabel(quotation.parcelCompany)"
            >
            <span v-if="quotation.isPreferred" class="preferred-star">&#9733;</span>
        </div>

        <div class="row mt-1 text-h6 justify-content-center" style="gap: 6px;">
            <Badge v-if="!shouldMergeHuipixCosts" outline type="info">{{quotation.service}}</Badge>
            <Badge outline type="info"><i class="fas fa-calendar-check"></i> {{ getMissingDaysMessage(quotation.deliveryDate) }}</Badge>
        </div>

        <div class="order-info-container mt-1 w-100" style="border-radius: 10px; gap: 12px;">
            <div class="row pa-1 justify-content-around">
                <div class="col-12 mb-1 row justify-content-center">
                    <PrimaryBadge
                        style="min-width: 180px;"
                        span="Total"
                        :label="`${formatCurrency(quotation.totalAmount)}`"
                    ></PrimaryBadge>
                </div>

                <ItemBadge
                    style="min-width: 112px;"
                    span="Envío"
                    class="mb-1"
                    :label="`${formatCurrency(quotation.price)}`"
                ></ItemBadge>

                <ItemBadge
                    v-if="!shouldMergeHuipixCosts"
                    style="min-width: 112px;"
                    span="Cruce"
                    class="mb-1"
                    :label="`${formatCurrency(quotation.importation)}`"
                ></ItemBadge>

                <ItemBadge
                    v-if="quotation.totalExtraCharges && quotation.totalExtraCharges !== 0"
                    style="min-width: 112px;"
                    span="Cargos"
                    class="mb-1"
                    :label="`${formatCurrency(quotation.totalExtraCharges)}`"
                ></ItemBadge>
                
                <ItemBadge
                    v-if="quotation.extendedArea && quotation.extendedArea !== 0"
                    style="min-width: 112px;"
                    span="Area Extendida"
                    class="mb-1"
                    :label="`${formatCurrency(quotation.extendedArea)}`"
                ></ItemBadge>
            </div>
        </div>

        <button class="btn-success mt-1 w-100" @click="$emit('onSelect')">GENERAR</button>
    </div>
</template>

<script>
import { computed } from 'vue';
import utils from '../../composables/utils';
import Badge from '../../global-components/Badge.vue';
import ItemBadge from '../../global-components/ItemBadge.vue';
import PrimaryBadge from '../../global-components/PrimaryBadge.vue';

export default {
    components: {
        Badge,
        ItemBadge,
        PrimaryBadge
    },
    props: {
        quotation: Object,
        classCard: String,
        mergeHuipixCosts: {
            type: Boolean,
            default: null
        }
    },
    setup (props) {
        const isHuipixHost = window?.location?.hostname === 'importaciones.huipixenvios.com.mx';
        const shouldMergeHuipixCosts = computed(() => {
            if (props.mergeHuipixCosts === null || props.mergeHuipixCosts === undefined) {
                return isHuipixHost;
            }

            return props.mergeHuipixCosts;
        });

        return {
            utils,
            shouldMergeHuipixCosts
        }
    },
    methods: {
        formatCurrency(number) {
            return number.toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD'
            });
        },
        getMissingDaysMessage(date) {
            const days = this.utils.getMissingDays(date);

            if (days > 1) return `Llega en ${days} días`;
            if (days === 1) return 'Llega mañana';
            if (days === 0) return 'Llega hoy';
            return `Venció hace ${Math.abs(days)} días`;
        }
    }
}
</script>
